export const mobileRegex: RegExp = /^\+?[1-9]\d{1,14}$/;

export const emailRegex: RegExp = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const passwordRegex: RegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,20}$/;

export const alphabetsRegex: RegExp = /^[a-zA-Z]+$/;

export const numberRegex: RegExp = /^\d+$/;
// Or if you want to allow empty input (e.g., while typing): /^[0-9]*$/

export const floatingPointNumberRegex: RegExp = /^(?:\d+(?:\.\d*)?|\.\d+)$/;

export const zipCodeRegex: RegExp = /^[A-Za-z0-9\s-]{3,10}$/;
